import { Stack, Shelf, Text, Icon } from "@chaser/components";
import { Minus, Plus } from "lucide-react";
import InfoTooltip from "@/components/InfoTooltip";
import styles from "../AddonOption.module.scss";

const QuantityControls = ({ config, state, handlers }) => {
  const {
    isVolume,
    currentSavingsPercent,
    resolvedQuantity,
    quantityStep,
    minQuantity,
    maxQuantity,
    volumeQuantityLabel,
    allowanceStyleLabel,
    info,
    sliderStyle,
    sliderPercent,
  } = config;

  const { quantityInput } = state;

  const {
    onQuantityInputChange,
    onQuantityInputFocus,
    onQuantityInputBlur,
    onQuantityInputKeyDown,
    setQuantity,
    clampToStep,
    handleSliderChange,
  } = handlers;

  return (
    <Stack
      className={`${styles.controlsCard} ${styles.controlsCardVolume}`}
      gap="medium"
    >
      <Shelf
        justifyContent="flex-start"
        alignItems="center"
        className={styles.quantityShelf}
      >
        <Stack gap="small" alignItems="flex-start">
          {currentSavingsPercent > 0 && !isVolume && (
            <div className={styles.savingsPill}>
              <Icon name="tick" size={12} color="Green" />
              <Text fontSize="xsmall" color="Green" fontWeight="medium">
                Saving {currentSavingsPercent}%
              </Text>
            </div>
          )}
          <Shelf
            gap="xsmall"
            alignItems="center"
            justifyContent="center"
            className={styles.volumeQuantityRow}
          >
            <button
              type="button"
              className={styles.quantityStepperButton}
              onClick={() =>
                setQuantity(clampToStep(resolvedQuantity - quantityStep))
              }
              disabled={resolvedQuantity <= minQuantity}
            >
              <Minus size={14} />
            </button>
            <input
              inputMode="numeric"
              type="text"
              value={quantityInput}
              onChange={onQuantityInputChange}
              onFocus={onQuantityInputFocus}
              onBlur={onQuantityInputBlur}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              onKeyDown={onQuantityInputKeyDown}
              className={styles.quantityInput}
              data-trackingid="addon-quantity-input"
            />
            <button
              type="button"
              className={styles.quantityStepperButton}
              onClick={() =>
                setQuantity(clampToStep(resolvedQuantity + quantityStep))
              }
              disabled={resolvedQuantity >= maxQuantity}
            >
              <Plus size={14} />
            </button>
            <Text fontSize="small" fontWeight="medium" color="Mid Neutral 1">
              {isVolume ? volumeQuantityLabel : allowanceStyleLabel}
            </Text>
            {info && <InfoTooltip position="top">{info}</InfoTooltip>}
          </Shelf>
        </Stack>
      </Shelf>

      <div className={styles.sliderWrap}>
        <input
          type="range"
          className={styles.addonOptionRange}
          min={minQuantity}
          max={maxQuantity}
          step={quantityStep}
          value={resolvedQuantity}
          onChange={handleSliderChange}
          style={sliderStyle}
          data-trackingid="addon-quantity-slider"
        />
        <div
          className={`${styles.thumbIndicator} ${styles.thumbIndicatorVolume}`}
          style={{
            left: `clamp(0px, calc(${sliderPercent}% - 10px), calc(100% - 20px))`,
          }}
          aria-hidden
        ></div>
        <Shelf justifyContent="space-between" className={styles.sliderBounds}>
          <Text color="Mid Neutral 2" fontSize="xsmall">
            {minQuantity}
          </Text>
          <Text color="Mid Neutral 2" fontSize="xsmall">
            {maxQuantity.toLocaleString()}
          </Text>
        </Shelf>
      </div>
    </Stack>
  );
};

export default QuantityControls;
